import { Get } from '../http/httpVerbs';

export const apiGetPostFormats = async () => {
    try {
        const response = await Get(`${process.env.REACT_APP_API_URL}/posts/formats`);
        
        return response;
    } catch (error) {
        console.error('API apiGetPostFormats ERROR:', error);
        throw error;
    }
};
